import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {WinPresentationView} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';

export class WinPresentationBasicState extends ModuleState<WinPresentationView, WinPresentationModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(FlowModuleEvents.WON, this.onWon);
	}

	protected onWon(): void {
		if (WinUtils.isBigWin(this.module.logic)) {
			this.module.gotoState(WinPresentationModule.INITIALBEFOREBIGWIN);
		} else {
			this.module.gotoState(WinPresentationModule.INITIAL);
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationBasicState.ts